import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "transparent",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#202020",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M6.158 7.487h-.777a3.071 3.071 0 0 0-3.071 3.07v4.063a3.07 3.07 0 0 0 3.07 3.07h9.276a3.07 3.07 0 0 0 3.07-3.07v-4.07c0-1.692-1.37-3.063-3.061-3.063h-.786M10.018 1.825V11.86M7.59 4.266l2.429-2.44 2.43 2.44"
    }, null, -1)
  ]))]))
}
export default { render: render }